export const RbacPermissions = {
  View: {
    Administrative: "View.Administrative",
    Collector: "View.Collector",
    PointOfSale: "View.PointOfSale",
  },
  Lottery: {
    Cancel: "Lottery.Ticket.Cancel",
  },
};

export enum AuthMode {
  All, // All permissions must be met
  Any // At least one permission must be met
}
